import { Button, Stack } from '@mui/material'
import { getTags } from 'api/tags'
import { useDrawersContext } from 'components/context/ClientsDrawersProvider'
import NotificationSys from 'components/NotificationSystem'
import HelpTooltip from 'components/tooltips/HelpTooltip'
import { searchTooltip } from 'components/tooltips/tooltips'
import { MIN_SEARCH_VALUE_LENGTH } from 'const'
import { useQuery } from 'react-query'
import { EOp, FilterModel } from 'types'
import { selectOptionsFromTableResponse } from 'utils'
import { useSearchInput } from '../useSearchInput'

const getTagFilterById = (id: number): FilterModel => ({
  tagId: {
    type: 'number',
    op: EOp.equals,
    value: id,
  },
})

export const AdminSearch = () => {
  const { handleOpenAdminSearchDrawer } = useDrawersContext()

  const tagsQuery = useQuery(['getTags'], () => getTags(), {
    select: selectOptionsFromTableResponse,
  })

  const { SearchInput, searchInput } = useSearchInput({
    options: tagsQuery.data,
    isLoading: tagsQuery.isLoading,
    getFilters: getTagFilterById,
    onSearch: handleOpenAdminSearchDrawer,
    isColorBackground: false,
  })

  const onSearch = () => {
    if (searchInput.trim().length < MIN_SEARCH_VALUE_LENGTH) {
      NotificationSys.showWarning('Please enter 3 symbols or more to be able to search.')
      return
    }

    handleOpenAdminSearchDrawer(searchInput, null)
  }

  return (
    <Stack direction="row">
      {SearchInput}

      <HelpTooltip text={searchTooltip} placement="top">
        <Button variant="text" onClick={onSearch}>
          Search
        </Button>
      </HelpTooltip>
    </Stack>
  )
}
